import { Injectable } from '@angular/core';
import { Http, Headers, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { environment } from '../../../environments/environment';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { Router } from '@angular/router';
import { GlobalService } from '../global.service';
@Injectable()
export class SellerDashboardService {

  constructor(private http: Http, private router: Router) { }
  
  public sellerInvoice  () {
    console.log('inside services');
    return this.http.get(environment.baseUrl + '/analytics/seller/invoice_amount',
    GlobalService.getHeaders()).map((response: Response) => {
      console.log(response.status);
      const user = response.json();
      user.responseStatus = response.status;
      console.log(user);
      return user;
    }).catch((error) => {
      console.log('error', error);
      if (error.status === 500) {
        console.log('status', error.status);
        const err = error.json();
        err.responseStatus = error.status;
        console.log('status', err.responseStatus);
        return Observable.throw(err);
      } else if (error.status === 400) {
        console.log('status', error.status);
        const err = error.json();
        err.responseStatus = error.status;
        console.log('status', err.responseStatus);
        return Observable.throw(err);
      }else if (error.status === 401) {
        console.log('status', error.status);
        const err = error.json(); 
        err.responseStatus = error.status;
        console.log('status', err.responseStatus);
        return Observable.throw(err);
      }
  });
  }
  public sellerAnalytics  () {
    console.log('inside services');
    return this.http.get(environment.baseUrl + '/analytics/seller/details',
    GlobalService.getHeaders()).map((response: Response) => {
      console.log(response.status);
      const user = response.json();
      user.responseStatus = response.status;
      console.log(user);
      return user;
    }).catch((error) => {
      console.log('error', error);
      if (error.status === 500) {
        console.log('status', error.status);
        const err = error.json();
        err.responseStatus = error.status;
        console.log('status', err.responseStatus);
        return Observable.throw(err);
      } else if (error.status === 400) {
        console.log('status', error.status);
        const err = error.json();
        err.responseStatus = error.status;
        console.log('status', err.responseStatus);
        return Observable.throw(err);
      }else if (error.status === 401) {
        console.log('status', error.status);
        const err = error.json(); 
        err.responseStatus = error.status;
        console.log('status', err.responseStatus);
        return Observable.throw(err);
      }
  });
  }
  public invicePaymentAmount  () {
    console.log('inside services');
    return this.http.get(environment.baseUrl + '/analytics/seller/invoices_payments_amount_analytics',
    GlobalService.getHeaders()).map((response: Response) => {
      console.log(response.status);
      const user = response.json();
      user.responseStatus = response.status;
      console.log(user);
      return user;
    }).catch((error) => {
      console.log('error', error);
      if (error.status === 500) {
        console.log('status', error.status);
        const err = error.json();
        err.responseStatus = error.status;
        console.log('status', err.responseStatus);
        return Observable.throw(err);
      } else if (error.status === 400) {
        console.log('status', error.status);
        const err = error.json();
        err.responseStatus = error.status;
        console.log('status', err.responseStatus);
        return Observable.throw(err);
      }else if (error.status === 401) {
        console.log('status', error.status);
        const err = error.json(); 
        err.responseStatus = error.status;
        console.log('status', err.responseStatus);
        return Observable.throw(err);
      }
  }); 
  }

  public invoicePayments() {
    console.log('inside services');
    return this.http.get(environment.baseUrl + '/analytics/seller/invoices_payments_analytics',
    GlobalService.getHeaders()).map((response: Response) => {
      console.log(response.status);
      const user = response.json();
      user.responseStatus = response.status;
      console.log(user);
      return user;
    }).catch((error) => {
      console.log('error', error);
      if (error.status === 500) {
        console.log('status', error.status);
        const err = error.json();
        err.responseStatus = error.status;
        console.log('status', err.responseStatus); 
        return Observable.throw(err);
      } else if (error.status === 400) {
        console.log('status', error.status);
        const err = error.json();
        err.responseStatus = error.status;
        console.log('status', err.responseStatus);
        return Observable.throw(err);
      }else if (error.status === 401) {
        console.log('status', error.status);
        const err = error.json(); 
        err.responseStatus = error.status;
        console.log('status', err.responseStatus);
        return Observable.throw(err);
      }
  }); 
  }


  public counterPartiesOutstandinsInvoives() {
    console.log('inside services');
    return this.http.get(environment.baseUrl + '/analytics/seller/counter_parties_with_outstanding_invoices',
    GlobalService.getHeaders()).map((response: Response) => {
      console.log(response.status);
      const user = response.json();
      user.responseStatus = response.status;
      console.log(user);
      return user;
    }).catch((error) => {
      console.log('error', error);
      if (error.status === 500) {
        console.log('status', error.status);
        const err = error.json();
        err.responseStatus = error.status;
        console.log('status', err.responseStatus); 
        return Observable.throw(err);
      } else if (error.status === 400) {
        console.log('status', error.status);
        const err = error.json();
        err.responseStatus = error.status;
        console.log('status', err.responseStatus);
        return Observable.throw(err);
      }else if (error.status === 401) {
        console.log('status', error.status);
        const err = error.json(); 
        err.responseStatus = error.status;
        console.log('status', err.responseStatus);
        return Observable.throw(err);
      }
  }); 
  }

  public sellerAmount  () {  
    console.log('inside services');
    return this.http.get(environment.baseUrl + '/analytics/seller/amount_financed',
    GlobalService.getHeaders()).map((response: Response) => {
      console.log(response.status);
      const user = response.json();
      user.responseStatus = response.status;
      console.log(user);
      return user;
    }).catch((error) => {
      console.log('error', error);
      if (error.status === 500) {
        console.log('status', error.status);
        const err = error.json();
        err.responseStatus = error.status;
        console.log('status', err.responseStatus);
        return Observable.throw(err);
      } else if (error.status === 400) {
        console.log('status', error.status);
        const err = error.json();
        err.responseStatus = error.status;
        console.log('status', err.responseStatus);
        return Observable.throw(err);
      }else if (error.status === 401) {
        console.log('status', error.status);
        const err = error.json(); 
        err.responseStatus = error.status;
        console.log('status', err.responseStatus);
        return Observable.throw(err);
      }
  });
  } 
  public getUserProfile() {
    console.log('inside services');
    const sellerId = localStorage.getItem('sellerEmail');
    const userId = sellerId
    return this.http.get(environment.baseUrl + '/user/getdetails/' + userId, GlobalService.getHeaders()).map((response: Response) => {
      console.log(response.status);
      const user = response.json();
      user.responseStatus = response.status;
      console.log(user);
      return user;
    }).catch((error) => {
      console.log('error', error);
      if (error.status === 500) {
        console.log('status', error.status);
        const err = error.json();
        err.responseStatus = error.status;
        console.log('status', err.responseStatus);
        return Observable.throw(err);
      } else if (error.status === 400) {
        console.log('status', error.status);
        const err = error.json();
        err.responseStatus = error.status;
        console.log('status', err.responseStatus);
        return Observable.throw(err);
      } else if (error.status === 401) {
        console.log('status', error.status);
        const err = error.json();
        err.responseStatus = error.status;
        console.log('status', err.responseStatus);
        return Observable.throw(err);
      }
  });
  
  }

  //// update password 
public  updatePassword (formdata) {
  const emailId = localStorage.getItem('userEmail')
   const data = {
     "emailId" : emailId,
     "oldPassword" : formdata.currentPassword,
     "newPassword" : formdata.newPassword
 }
     console.log('data', data);
     const body = JSON.stringify(data);
     console.log(body);
     return this.http.post(environment.baseUrl + '/user/reset__password', body,
     GlobalService.getHeaders()).map((response: Response) => {
       console.log(response.status);
       const user = response.json();
       user.responseStatus = response.status;
       console.log(user);
       return user;
     }).catch((error) => {
       console.log('error', error);
       if (error.status === 500) {
         console.log('status', error.status);
         const err = error.json();
         err.responseStatus = error.status;
         console.log('status', err.responseStatus);
         return Observable.throw(err);
       } else if (error.status === 400) {
         console.log('status', error.status);
         const err = error.json();
         err.responseStatus = error.status;
         console.log('status', err.responseStatus);
         return Observable.throw(err);
       } else if (error.status === 401) {
         console.log('status', error.status);
         const err = error.json();
         err.responseStatus = error.status;
         console.log('status', err.responseStatus);
         return Observable.throw(err);
       }
   });
   }

   public getlimits() {
    console.log("inside services");
    const sellerId = localStorage.getItem("sellerId");
    return this.http
      .get(
        environment.baseUrl + "/user/viewmaxlimit/" + sellerId,
        GlobalService.getHeaders()
      )
      .map((response: Response) => {
        console.log(response.status);
        const user = response.json();
        user.responseStatus = response.status;
        console.log(user);
        return user;
      })
      .catch((error) => {
        console.log("error", error);
        if (error.status === 500) {
          console.log("status", error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log("status", err.responseStatus);
          return Observable.throw(err);
        } else if (error.status === 400) {
          console.log("status", error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log("status", err.responseStatus);
          return Observable.throw(err);
        } else if (error.status === 401) {
          console.log("status", error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log("status", err.responseStatus);
          return Observable.throw(err);
        }
      });
  }

  public totalDiscountedInvoices() {
    console.log("inside services");
    const sellerId = localStorage.getItem("sellerId");
    return this.http
      .get(
        environment.baseUrl + "/analytics/seller/total_discounted_invoices",
        GlobalService.getHeaders()
      )
      .map((response: Response) => {
        console.log(response.status);
        const user = response.json();
        user.responseStatus = response.status;
        console.log(user);
        return user;
      })
      .catch((error) => {
        console.log("error", error);
        if (error.status === 500) {
          console.log("status", error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log("status", err.responseStatus);
          return Observable.throw(err);
        } else if (error.status === 400) {
          console.log("status", error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log("status", err.responseStatus);
          return Observable.throw(err);
        } else if (error.status === 401) {
          console.log("status", error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log("status", err.responseStatus);
          return Observable.throw(err);
        }
      });
  }

  public totalInvoices() {
    console.log("inside services");
    const sellerId = localStorage.getItem("sellerId");
    return this.http
      .get(
        environment.baseUrl + "/analytics/seller/total_invoices",
        GlobalService.getHeaders()
      )
      .map((response: Response) => {
        console.log(response.status);
        const user = response.json();
        user.responseStatus = response.status;
        console.log(user);
        return user;
      })
      .catch((error) => {
        console.log("error", error);
        if (error.status === 500) {
          console.log("status", error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log("status", err.responseStatus);
          return Observable.throw(err);
        } else if (error.status === 400) {
          console.log("status", error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log("status", err.responseStatus);
          return Observable.throw(err);
        } else if (error.status === 401) {
          console.log("status", error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log("status", err.responseStatus);
          return Observable.throw(err);
        }
      });
  }


  public counerPartyOnboarded() {
    console.log("inside services");
    const sellerId = localStorage.getItem("sellerId");
    return this.http
      .get(
        environment.baseUrl + "/analytics/seller/counter_parties_onboarded",
        GlobalService.getHeaders()
      )
      .map((response: Response) => {
        console.log(response.status);
        const user = response.json();
        user.responseStatus = response.status;
        console.log(user);
        return user;
      })
      .catch((error) => {
        console.log("error", error);
        if (error.status === 500) {
          console.log("status", error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log("status", err.responseStatus);
          return Observable.throw(err);
        } else if (error.status === 400) {
          console.log("status", error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log("status", err.responseStatus);
          return Observable.throw(err);
        } else if (error.status === 401) {
          console.log("status", error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log("status", err.responseStatus);
          return Observable.throw(err);
        }
      });
  }
}
  